"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInvalidWaitAcceptCmd = exports.isInvalidMessage = void 0;
var isInvalidSendAccept = function (message) { return message.cmd === "USER_CHANGES" /* USER_CHANGES */
    && !message.onsendAccept; };
var isInvalidWaitAcceptCmd = function (message) {
    var _a;
    if (message.onsendAccept
        && (!((_a = message.customParam) === null || _a === void 0 ? void 0 : _a.waitAcceptCmd)
            || Object.prototype.toString.call(message.customParam.waitAcceptCmd) !== '[object Array]'
            || message.customParam.waitAcceptCmd.length === 0)) {
        return true;
    }
    return false;
};
exports.isInvalidWaitAcceptCmd = isInvalidWaitAcceptCmd;
var isInvalidMessage = function (message) { return isInvalidSendAccept(message)
    || isInvalidWaitAcceptCmd(message); };
exports.isInvalidMessage = isInvalidMessage;
